import * as React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'

type Props = {
  title: string
  description: string
  steps: { title: string; description: string; image: any }[]
  buttonText?: string
}

export const HowItWorksSection: React.FC<Props> = ({ title, description, steps, buttonText }) => {
  return (
    <section className={'text-center'}>
      <Container>
        <h2 style={{ fontSize: 40, color: 'black', fontWeight: 700 }}>{title}</h2>
        <p className="pb-2" style={{ color: '#7c7c7c' }}>
          {description}
        </p>
        <div
          className={'grid md:grid-cols-3'}
          style={{
            boxShadow:
              '0 13px 27px -5px rgba(50, 50, 93, .25), 0 8px 16px -8px rgba(0, 0, 0, .3), 0 -6px 16px -6px rgba(0, 0, 0, .025)',
          }}
        >
          {steps.map((value, index) => (
            <HowItWorksStep key={index} {...value} />
          ))}
        </div>
        {buttonText && (
          <div className="pt-5">
            <LandingPageButton buttonText={buttonText} />
          </div>
        )}
      </Container>
    </section>
  )
}

const HowItWorksStep: React.FC<{
  title: string
  description: string
  image: any
}> = ({ title, description, image }) => {
  return (
    <div
      className="flex flex-grow flex-col h-100 px-5"
      style={{
        backgroundColor: 'white',
        border: '1px solid rgb(220, 219, 219)',
        paddingTop: '75px',
        paddingBottom: '75px',
      }}
    >
      <Image src={image} width={60} height={60} alt={title} className="mx-auto" />
      <div className="mt-auto">
        <h3 style={{ paddingTop: '20px', fontSize: '18px', fontWeight: 900 }}>{title}</h3>
        <p className="description m-0">{description}</p>
      </div>
    </div>
  )
}
